import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Form, Loading } from 'components';

class PaymentForm extends Component {
  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleChangeInput = e => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  render() {
    const { data } = this.state;
    const { saving, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Meio de Pagamento</h3>

        <Form.Field>
          <Form.Label>Código</Form.Label>
          <Form.Input
            name="external_id"
            placeholder="Código"
            value={data.external_id}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Nome</Form.Label>
          <Form.Input name="name" placeholder="Nome" value={data.name} onChange={this.handleChangeInput} />
        </Form.Field>

        <Form.Field>
          <Form.Label>Tipo</Form.Label>
          <Form.Input
            name="type_payment"
            placeholder="Tipo de Pagamento"
            value={data.type_payment}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.Input
            name="description"
            placeholder="Descrição"
            value={data.description}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Esse meio de pagamento pontua</Form.Label>
          <Form.Checkbox checked={data.score} onChange={this.handleToggleScore} />
        </Form.Field>

        <div className="buttons">
          <Link to="/points/payments" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button className="button-save" onClick={onSubmit} disabled={saving}>
            {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

export default PaymentForm;
